
import dayjs from "dayjs";


const formatAmount = (value) => {
    if (value == null) return "—";
    return Number(value).toLocaleString("en-KE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const formatDate = (value) =>
    value ? dayjs(value).format("DD-MM-YYYY") : "—";

const formatCellValue = (value, column) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  if (column.type === "money" || column.type === "currency" || column.type === "number") {
    return formatAmount(value);
  }

  if (column.type === "date") {
    return formatDate(value);
  }

  return value;
};

const getCellClassName = (column) => {
  return column.align === "right" ? "cell-align-right" : "";
};

const StandardReportTable = ({ columns = [], rows = [], totals = {} }) => {
  return (
    <table>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key} className={getCellClassName(column)}>
              {column.label}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {rows.map((row, index) => (
          <tr key={row.id || index}>
            {columns.map((column) => (
              <td key={column.key} className={getCellClassName(column)}>
                {formatCellValue(row[column.key], column)}
              </td>
            ))}
          </tr>
        ))}

        {rows.length === 0 && (
          <tr>
            <td colSpan={columns.length}>No records found.</td>
          </tr>
        )}
      </tbody>

      {totals && (
        <tfoot>
          <tr>
            {columns.map((column, index) => {
              if (index === 0) {
                return (
                  <td key={column.key}>
                    TOTALS
                  </td>
                );
              }

              if (totals[column.key] !== undefined) {
                return (
                  <td key={column.key} className={getCellClassName(column)}>
                    {formatCellValue(totals[column.key], column)}
                  </td>
                );
              }

              return <td key={column.key}></td>;
            })}
          </tr>
        </tfoot>
      )}
    </table>
  );
};

export default StandardReportTable;